"use strict";
class PredictiveFaqSearch extends HTMLElement {
    constructor() {
        super();
        this.cachedResults = {};
        this.input = this.querySelector('input[data-type="faqsearch"]');
        this.predictiveFaqSearchResults = this.querySelector("[data-predictive-faq-search]");
        this.isOpen = false;
        this.isInsideResults = false; // 标记是否在结果内部
        this.mql = window.matchMedia("(max-width: 989px)");
        this.setupEventListeners();
    }

    setupEventListeners() {
        this.querySelector("form").addEventListener("submit", this.onFormSubmit.bind(this));
        this.input.addEventListener("input", (event) => {
            // Prevent the theme's product predictive-search from handling this FAQ input.
            event.stopImmediatePropagation();
            event.stopPropagation();
            this.closeProductSearch();
            this.onInputChange();
        }, true);
        this.input.addEventListener("focus", this.onFocus.bind(this));

        // 监听 focusout 事件
        this.addEventListener("focusout", this.onFocusOut.bind(this));

        // 监听点击事件，确保在点击外部时关闭弹窗
        document.addEventListener("click", (event) => {
            if (this.isOpen && !this.contains(event.target)) {
                this.close();
            }
        });

        this.predictiveFaqSearchResults.addEventListener("mousedown", () => {
            this.isInsideResults = true; // 在搜索结果内
        });

        this.predictiveFaqSearchResults.addEventListener("mouseup", () => {
            this.isInsideResults = false; // 清除标记
        });
    }

    getQuery() {
        return this.input.value.trim();
    }

    onInputChange() {
        const searchTerm = this.getQuery();
        if (!searchTerm.length) {
            this.close(true);
            return;
        }
        this.getSearchResults(searchTerm);
    }

    onFormSubmit(event) {
        if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) {
            event.preventDefault();
        }
    }

    onFocus() {
        const searchTerm = this.getQuery();
        if (searchTerm.length) {
            this.getAttribute("results") === "true" ? this.open() : this.getSearchResults(searchTerm);
        }
    }

    onFocusOut(event) {
        const isInsideInput = this.input === document.activeElement;
        // 只有在不在输入框和结果列表时才关闭
        if (!isInsideInput && !this.isInsideResults) {
            setTimeout(() => {
                this.close();
            }, 0);
        }
    }

    getSearchResults(searchTerm) {
        const queryKey = searchTerm.replace(" ", "-").toLowerCase();
        
        if (this.cachedResults[queryKey]) {
            this.renderSearchResults(this.cachedResults[queryKey]);
            return;
        }

        fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&resources[type]=article&resources[limit]=4&section_id=predictive-faq-search`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(response.status);
                }
                return response.text();
            })
            .then((text) => {
                const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#shopify-section-predictive-faq-search").innerHTML;
                this.cachedResults[queryKey] = resultsMarkup;
                this.renderSearchResults(resultsMarkup);
            })
            .catch((error) => {
                this.close();
                console.error(error);
            });
    }

    renderSearchResults(resultsMarkup) {
        this.predictiveFaqSearchResults.innerHTML = resultsMarkup;
        this.setAttribute("results", true);
        this.open();
    }

    closeProductSearch() {
        document.querySelectorAll("predictive-search").forEach((element) => {
            if (typeof element.close === "function") {
                element.close();
            } else {
                element.removeAttribute("open");
            }

            const input = element.querySelector('input[type="search"]');
            input?.setAttribute("aria-expanded", "false");
        });
    }

    open() {
        this.closeProductSearch();
        this.setAttribute("open", true);
        this.input.setAttribute("aria-expanded", true);
        this.isOpen = true;
    }

    close(clearSearchTerm = false) {
        if (clearSearchTerm) {
            this.input.value = "";
            this.removeAttribute("results");
        }
        this.removeAttribute("open");
        this.input.setAttribute("aria-expanded", false);
        this.isOpen = false;
    }
}

customElements.define("predictive-faq-search", PredictiveFaqSearch);
